import React, { useMemo } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { DatePickerQuestion } from "../../types";

interface DatePickerQuestionProps {
  question: DatePickerQuestion;
  value: string;
  onChange: (value: string) => void;
}

const parseDateValue = (value: string): Dayjs | null => {
  if (!value) return null;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed : null;
};

export const DatePickerQuestionField: React.FC<DatePickerQuestionProps> = ({
  question,
  value,
  onChange,
}) => {
  const parsedValue = useMemo(() => parseDateValue(value), [value]);

  return (
    <DatePicker
      format="DD/MM/YYYY"
      value={parsedValue}
      onChange={(newValue) => {
        if (!newValue || !newValue.isValid()) {
          onChange("");
          return;
        }
        onChange(newValue.format("YYYY-MM-DD"));
      }}
      slotProps={{
        textField: {
          fullWidth: true,
          placeholder: question.placeholder,
        },
      }}
    />
  );
};
